exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page[data-v-1de7c92a]{padding-top:60px}.page .form[data-v-1de7c92a]{margin-top:20px}.page .form table[data-v-1de7c92a]{margin-bottom:15px}.page .form table tr td[data-v-1de7c92a]{padding:3px 0;font-size:14px}.page .form table tr td[data-v-1de7c92a]:nth-child(2){padding:0 5px 0 10px}.page .form table tr td[data-v-1de7c92a]:last-child{font-weight:600}.page .form .token[data-v-1de7c92a]{display:grid;grid-template-columns:1fr 1fr;border:1px solid #999;border-radius:8px;margin-bottom:20px;overflow:hidden}.page .form .token img[data-v-1de7c92a]{width:100%}.page .btn-scan[data-v-1de7c92a]{position:fixed;bottom:20px;left:20px;width:calc(100% - 40px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1de7c92a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Pengambilan.vue
// module id = 204
// module chunks = 0